import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Institution } from 'cb-model';

export interface InstitutionMemberRow {
  id: number;
  institution_id: number;
  user_id: string;
  is_admin: boolean;
  is_verified: boolean;
  invited_by: string | null;
  created_at: string;
}

export const InstitutionMember: Entity<InstitutionMemberRow> = {
  id: 'InstitutionMember',
  title: 'Institution Membership',
  service: 'main',
  rowLabel: (row: InstitutionMemberRow) => [row.institution_id, row.user_id].join(' / '),
  rowLabelDynamic: (row: InstitutionMemberRow) => `<lookup:UserView:${row.user_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_member',
  },
  security: [
    { role: 'admin', action: 'all', access: 'conditional', condition: 'institution_id = {adminInstitutionId}' },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['created_at', 'ASC']],
  defaultFilters: [{ fieldId: 'institution_id', operator: 'eq', value: '' }],
  listRowLink: '/admin/institution-member/display/{key}',
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
      autoIncrement: true,
    },
    institution_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Institution',
      mandatory: true,
      listColumn: true,
      refEntity: Institution,
    },
    user_id: {
      seq: 15,
      type: FieldType.Text,
      label: 'User',
      mandatory: true,
      listColumn: true,
      // turned into a Reference field in UserView
    },
    is_admin: {
      seq: 20,
      type: FieldType.Boolean,
      label: 'Is Admin?',
      listColumn: true,
    },
    is_verified: {
      seq: 25,
      type: FieldType.Boolean,
      label: 'Is Member?',
      listColumn: true,
    },
    invited_by: {
      seq: 28,
      type: FieldType.Text,
      label: 'Invited By',
      persistence: PersistenceType.BackEndManaged,
    },
    created_at: {
      seq: 30,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
  },
};
